"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var utils_1 = require("@idp/ui-components/utils");
var SavingsAndPromos_1 = require("../../panels/SavingsAndPromos");
var wlsUtils = require("../../../utils/WirelessUtilFunctions");
var Utils = require("../../../utils/UtilityFunctions");
var CartUtils = require("../../../utils/CartUtilFunctions");
var Common = require("../../../utils/CommonUtilFuntions");
var CartUtilFunctions_1 = require("../../../utils/CartUtilFunctions");
var ui_components_1 = require("@idp/ui-components");
var styles = require("./WirelessCart.scss");
var PriceContainerProps_1 = require("@idp/ui-components/components/cards/PriceContainer/PriceContainerProps");
var CartConfiguration_scss_1 = require("../../CartConfigurationContainer/CartConfiguration.scss");
var PromoPanel_1 = require("../../panels/PromoPanel");
var cms_integration_1 = require("@idp/cms-integration");
var Cart_cms_1 = require("../../../cms/Cart.cms");
var PromoPanel_scss_1 = require("../../panels/PromoPanel/PromoPanel.scss");
var ReportingService_1 = require("../../../api/ReportingService");
var components_1 = require("@idp/duc/components");
var icons = require("../../../styles/ccc-icons-cart.scss");
/**
 * Presentational component for Wireless Cart Flow.
 *
 * @export
 * @class WirelessCart
 * @extends WirelessSavings
 */
var WirelessSavings = /** @class */ (function () {
    function WirelessSavings() {
        this.isMixAndMatch = false;
        this.isSignatureFlagEnabled = false;
        this.actFeeTotal = 0;
        this.totalMonthlySavings = 0;
        this.totalOneTimeSavings = 0;
        this.upgFeeTotal = 0;
        this.isMultiLine = false;
        this.rewardInfo = {};
        this.oneTimeCombinedCategory = ['IRUPLANDISCOUNT', 'ACCESSORY', 'ACTIVATION_FEE', 'UPGRADEFEE',
            'ONLINEDISCOUNT', 'ACCESSORYDISCOUNT'];
        this.reportingService = new ReportingService_1.default();
        this.getSavingsAndPromos = this.getSavingsAndPromos.bind(this);
        this.getPromoLine = this.getPromoLine.bind(this);
        this.getSavingTitle = this.getSavingTitle.bind(this);
        this.isMonthlyCommonPromo = this.isMonthlyCommonPromo.bind(this);
        this.isOneTimeCommonPromo = this.isOneTimeCommonPromo.bind(this);
        this.getPromotions = this.getPromotions.bind(this);
        this.getMonthlySavings = this.getMonthlySavings.bind(this);
        this.getOneTimeSavings = this.getOneTimeSavings.bind(this);
        this.getOneTimePromoFromReferences = this.getOneTimePromoFromReferences.bind(this);
        this.getOneTimePromotion = this.getOneTimePromotion.bind(this);
        this.getSavingLine = this.getSavingLine.bind(this);
        this.getRewards = this.getRewards.bind(this);
        this.getDeviceModel = this.getDeviceModel.bind(this);
        this.showSavings = this.showSavings.bind(this);
        this.combinedMonthlySavings = this.combinedMonthlySavings.bind(this);
        this.showMonthlySavings = this.showMonthlySavings.bind(this);
        this.showRewardModalContent = this.showRewardModalContent.bind(this);
        this.openRewardModal = this.openRewardModal.bind(this);
    }
    WirelessSavings.prototype.getSavingsAndPromos = function (savingsInfo) {
        var _a, _b, _c, _d;
        this.monthlyCommonPromo = [];
        this.savingsAndPromosCms = wlsUtils.getSavingsAndPromosCmsData();
        this.promoPanelCmsData = (_c = (_b = (_a = cms_integration_1.CMS.get(new Cart_cms_1.CartCms(), 'cartcheckout')) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.common) === null || _c === void 0 ? void 0 : _c.promoPanel;
        var isACPMsgShouldBeShown = !!(Utils.getIXPFlagValue('svc-show-acp-message'));
        if (savingsInfo && savingsInfo.payLoad && savingsInfo.losgData) {
            var filteredLosgsData = savingsInfo.losgData;
            this.payloadObj = savingsInfo.payLoad;
            var promotions = savingsInfo.promotions || [];
            var savingsPromoFlags = savingsInfo.savingsPromoFlags || {};
            this.eapFlowContext = savingsInfo.eapFlowContext;
            this.totalMonthlySavings = this.payloadObj.wirelessCart.savingsInfo &&
                this.payloadObj.wirelessCart.savingsInfo.totalMonthlySavings || 0;
            this.totalOneTimeSavings = this.payloadObj.wirelessCart.savingsInfo &&
                this.payloadObj.wirelessCart.savingsInfo.totalOneTimeSavings || 0;
            this.isMixAndMatch = savingsInfo.isMixAndMatch;
            this.savingsData = savingsInfo;
            this.isSignatureFlagEnabled = this.payloadObj.enableSignatureEnhancedExperience;
            this.isMultiLine = filteredLosgsData.length > 1 ? true : false;
            var savingLabel = '';
            if (this.totalMonthlySavings && this.totalOneTimeSavings && this.savingsAndPromosCms &&
                this.savingsAndPromosCms.combiendSavingsLabel) {
                savingLabel = this.savingsAndPromosCms.combiendSavingsLabel;
                savingLabel = savingLabel.replace('{0}', Utils.amountWithDecimal(this.totalMonthlySavings, 2, '$'));
                savingLabel = savingLabel.replace('{1}', Utils.amountWithDecimal(this.totalOneTimeSavings, 2, '$'));
            }
            else if (this.totalMonthlySavings && this.savingsAndPromosCms &&
                this.savingsAndPromosCms.monthlySavingsLabel) {
                savingLabel = this.savingsAndPromosCms.monthlySavingsLabel.replace('{0}', Utils.amountWithDecimal(this.totalMonthlySavings, 2, '$'));
            }
            else if (this.totalOneTimeSavings && this.savingsAndPromosCms &&
                this.savingsAndPromosCms.oneTimeSavingsLabel) {
                savingLabel = this.savingsAndPromosCms.oneTimeSavingsLabel.replace('{0}', Utils.amountWithDecimal(this.totalOneTimeSavings, 2, '$'));
            }
            else {
                savingLabel = '';
            }
            return (React.createElement(React.Fragment, null,
                React.createElement(SavingsAndPromos_1.default, { data: {
                        losgData: filteredLosgsData,
                        monthlyInfo: {
                            monthlySavingsContent: this.getMonthlySavings(filteredLosgsData, promotions),
                            totalMonthlySavings: this.totalMonthlySavings,
                        },
                        oneTimeInfo: {
                            oneTimeSavingsContent: this.getOneTimeSavings(filteredLosgsData, promotions),
                            totalOneTimeSavings: this.totalOneTimeSavings,
                        },
                        panelContent: {
                            panelLabel: this.savingsAndPromosCms.panelLabel,
                            savingLabel: savingLabel,
                        },
                        payLoad: this.payloadObj,
                        showPanel: true,
                    }, options: { expandedView: savingsPromoFlags.savingsPromoComponentExpandedByDefault,
                        isExpressFlow: this.savingsData.isExpressFlow } }),
                isACPMsgShouldBeShown && !CartUtils.isSMBCustomer() &&
                    React.createElement("h6", { className: PromoPanel_scss_1.staticContent }, (_d = this.promoPanelCmsData) === null || _d === void 0 ? void 0 : _d.acpStaticContentMsg),
                React.createElement(PromoPanel_1.default, { data: {
                        cartPage: true,
                        displayCloserCoupon: savingsInfo.promoPanelOptions.displayCloserCoupon,
                        losgData: filteredLosgsData,
                    }, events: {
                        doLoading: savingsInfo.promoPanelEvents.doLoading,
                        priceBarUpdates: savingsInfo.promoPanelEvents.priceBarUpdates,
                        showSaveCartModal: savingsInfo.promoPanelEvents.showSaveCartModal,
                    }, options: {
                        autoExpandPromoSection: savingsInfo.promoPanelOptions.autoExpandPromoSection,
                        isNewSavingsPromoComponent: true,
                    } }),
                this.showRewardModalContent()));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    WirelessSavings.prototype.getPromoLine = function (losg, index, wlsCMSData, eapFlowInfo, deviceInfo) {
        return (React.createElement("div", { className: styles.savingsLine },
            React.createElement("span", null,
                wlsUtils.getLineNames(losg, index, wlsCMSData, eapFlowInfo, this.isMultiLine),
                ": "),
            deviceInfo.make && React.createElement("span", null,
                " ",
                deviceInfo.make,
                " ",
                deviceInfo.model)));
    };
    WirelessSavings.prototype.getSavingTitle = function (label, savings, cycle) {
        var promoPriceObj = wlsUtils.promoCyclePriceMsg(savings, cycle, true);
        return (React.createElement("div", { className: styles.savingsLineItem },
            React.createElement("div", { className: styles.savingsTitleText },
                React.createElement(ui_components_1.RichText, { testId: utils_1.default('Wireless', cycle, 'SavingTitle'), data: { isDecodingRequired: false, text: label } })),
            React.createElement("div", { className: styles.savingsPriceB },
                React.createElement(ui_components_1.PriceContainer, { testId: cycle + '_Saving_Price', data: { billingNote: cycle === 'MONTHLY' ? '' : promoPriceObj.suffix, price: savings }, options: { accessibility: promoPriceObj.catoConten, decimalPoints: 2,
                        isDataPriceNegative: false,
                        overrideAccessibility: true, type: PriceContainerProps_1.PricingType.XSMALL } }))));
    };
    WirelessSavings.prototype.isMonthlyCommonPromo = function (lineItem, promotion) {
        if (lineItem && lineItem.itemType.toUpperCase() === 'SHAREDDATAFEATURE' ||
            lineItem.itemType.toUpperCase() === 'SHAREDDATAGROUP' || lineItem.itemType.toUpperCase() === 'VOICEPLAN') {
            if (this.isMixAndMatch) {
                this.combinedMonthlySavings(promotion);
                return false;
            }
            else {
                this.monthlyCommonPromo.push(this.getPromotions(promotion));
                return true;
            }
        }
        else {
            this.combinedMonthlySavings(promotion);
            return false;
        }
    };
    WirelessSavings.prototype.isOneTimeCommonPromo = function (lineItem, promotion) {
        if (lineItem && lineItem.itemType && promotion && promotion.promotionCategory &&
            promotion.promotionCycle.toUpperCase() === 'ONETIME') {
            var promo = Object.assign({}, promotion);
            var promoCategory = promo.promotionCategory.toUpperCase();
            if (promoCategory && this.oneTimeCombinedCategory.indexOf(promoCategory) !== -1
                && this.oneTimeCombinedPromo[promoCategory] &&
                this.oneTimeCombinedPromo[promoCategory].amount) {
                var totalAmount = Number(this.oneTimeCombinedPromo[promoCategory].amount) + Number(promo.amount);
                this.oneTimeCombinedPromo[promoCategory] = promo;
                this.oneTimeCombinedPromo[promoCategory].amount = totalAmount;
                return true;
            }
            else {
                if (promoCategory && this.oneTimeCombinedCategory.indexOf(promoCategory) !== -1) {
                    this.oneTimeCombinedPromo[promoCategory] = promo;
                    return true;
                }
                else {
                    return false;
                }
            }
        }
        else {
            return false;
        }
    };
    WirelessSavings.prototype.combinedMonthlySavings = function (promotion) {
        if (promotion && promotion.promotionCycle && promotion.promotionCycle.toUpperCase() === 'MONTHLY' &&
            promotion.promotionCategory) {
            var promo = Object.assign({}, promotion);
            if (promo.promotionCategory.toUpperCase() === 'HYLA_TRADEIN' ||
                promo.promotionCategory.toUpperCase() === 'STACKABLE_STANDALONE_PROMO') {
                var promoCategory = 'STACKABLE_STANDALONE_PROMO_HYLA_TRADEIN';
                var promoCode = promotion.id;
                var isPromoDurationDifferent = this.monthlyCombinedPromo[promoCategory] &&
                    this.monthlyCombinedPromo[promoCategory].duration !== promo.duration;
                var combinedAmountTotal = void 0;
                var amountTotal = void 0;
                if (!isPromoDurationDifferent) {
                    combinedAmountTotal = this.monthlyCombinedPromo[promoCategory] &&
                        this.monthlyCombinedPromo[promoCategory].monthlyAmount || 0;
                    combinedAmountTotal = combinedAmountTotal + Number(promo.monthlyAmount);
                    this.monthlyCombinedPromo[promoCategory] = promo;
                    this.monthlyCombinedPromo[promoCategory].monthlyAmount = combinedAmountTotal;
                    this.monthlyCombinedPromo[promoCategory].promotionCategory = promoCategory;
                    return true;
                }
                else {
                    amountTotal = this.monthlyCombinedPromo[promoCode] &&
                        this.monthlyCombinedPromo[promoCode].monthlyAmount || 0;
                    amountTotal = amountTotal + Number(promo.monthlyAmount);
                    this.monthlyCombinedPromo[promoCode] = promo;
                    this.monthlyCombinedPromo[promoCode].monthlyAmount = amountTotal;
                    this.monthlyCombinedPromo[promoCode].promotionCategory = promoCategory;
                    return true;
                }
            }
            else {
                var promoCategory = promo.promotionCategory.toUpperCase();
                this.monthlyCombinedPromo[promoCategory] = promo;
                return false;
            }
        }
        else {
            var promo = Object.assign({}, promotion);
            var promoCategory = promotion.id;
            this.monthlyCombinedPromo[promoCategory] = promo;
            return false;
        }
    };
    WirelessSavings.prototype.getPromotions = function (promotion) {
        var _this = this;
        var _a, _b;
        if (promotion) {
            var priceData = {
                billingNote: promotion.promotionCycle && promotion.promotionCycle.toString(),
                price: Number(promotion.amount),
            };
            if (promotion.promotionCycle && promotion.promotionCycle.toUpperCase() === 'MONTHLY' &&
                promotion.monthlyAmount !== undefined) {
                priceData.price = Number(promotion.monthlyAmount);
            }
            var isPriceNegative = true;
            var deviceBillCreditFlag_1 = false;
            var newDeviceBillCredit_1 = '';
            var billingMsg = wlsUtils.promoCyclePriceMsg(priceData.price, priceData.billingNote, isPriceNegative);
            var showPriceAmt = (priceData && (priceData.price > 0) && promotion.promotionCycle) ? true : false;
            var promotionName = promotion.promotionName;
            var promotionCategory = promotion.promotionCategory && promotion.promotionCategory.toUpperCase();
            var imageStyle = [icons.cccIconCart, icons.cccIconCartSignatureBookmark].join(' ');
            if (promotion.promotionType === 'BILLCREDITWITHQUALIFIER'
                || promotion.promotionType === 'MANUALBILLCREDIT') {
                if (promotion.duration > 0) {
                    var deviceBillCredit_1 = this.savingsAndPromosCms.byodDeviceBillCredit || 'Device bill credit of {0} mos';
                    deviceBillCredit_1 = deviceBillCredit_1.replace('{0}', (_a = (promotion.duration)) === null || _a === void 0 ? void 0 : _a.toString());
                    var losgsData = Object.values(this.payloadObj.wirelessCart.losgs);
                    losgsData.forEach(function (losg) {
                        var lineItems = wlsUtils.organizeLineItems(Object.values(losg.lineItems), _this.isMixAndMatch);
                        for (var _i = 0, lineItems_1 = lineItems; _i < lineItems_1.length; _i++) {
                            var element = lineItems_1[_i];
                            if (element.contractDetails && element.contractDetails.contractLength !==
                                promotion.duration) {
                                deviceBillCreditFlag_1 = true;
                                newDeviceBillCredit_1 = deviceBillCredit_1;
                            }
                        }
                    });
                }
            }
            switch (promotionCategory) {
                case 'ABPDISCOUNT':
                    promotionName = this.savingsAndPromosCms.autoPayLabel || 'AutoPay and paperless billing discount.';
                    break;
                case 'STACKABLE_STANDALONE_PROMO_HYLA_TRADEIN':
                    if (promotion.promotionCycle && promotion.promotionCycle.toUpperCase() === 'MONTHLY') {
                        if (deviceBillCreditFlag_1) {
                            promotionName = showPriceAmt ?
                                newDeviceBillCredit_1 :
                                promotion.promotionName;
                        }
                        else {
                            promotionName = showPriceAmt ?
                                this.savingsAndPromosCms.deviceBillCreditLabel || 'Device bill credit' :
                                promotion.promotionName;
                        }
                    }
                    break;
                case 'ACCESSORY':
                    promotionName =
                        this.savingsAndPromosCms.accessoryDiscountLabel || 'Accessory discount(s)';
                    break;
                default:
                    promotionName = promotion.promotionName;
            }
            return (React.createElement("div", { key: promotion.id, className: styles.savingsLineItem },
                React.createElement("div", { className: styles.savingsContentB },
                    this.isSignatureFlagEnabled && ((promotion === null || promotion === void 0 ? void 0 : promotion.promotionCategory) === 'iruPlanDiscount'
                        || ((_b = promotion === null || promotion === void 0 ? void 0 : promotion.discountCategory) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === 'noncontractual') &&
                        !CartUtilFunctions_1.isSMBCustomer() && !CartUtilFunctions_1.isFNIntentPresent() &&
                        !CartUtils.isFNUserWithConsumerLine() &&
                        React.createElement("span", { className: styles.iconBookmark32 }, (CartUtilFunctions_1.isAppreciationOfferPresent()) ?
                            React.createElement("img", { className: styles.appreciationIcon, src: 'https://www.att.com/idpassets/global/icons/svg/retail-financial/functional-icon_financial-security-filled_32.svg', alt: 'appreciationIcon' }) : React.createElement("i", { "aria-label": "Icon", className: imageStyle })),
                    React.createElement(ui_components_1.RichText, { testId: utils_1.default('Wireless', priceData.billingNote, 'SavingPromo'), data: { isDecodingRequired: false, text: promotionName } })),
                showPriceAmt && React.createElement("div", { className: styles.savingsPriceB },
                    React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('Wireless', priceData.billingNote, 'SavingPrice'), data: { billingNote: billingMsg.suffix, price: priceData.price }, options: { accessibility: billingMsg.catoConten, decimalPoints: 2,
                            isDataPriceNegative: isPriceNegative,
                            overrideAccessibility: true, type: PriceContainerProps_1.PricingType.XSMALL } }))));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    WirelessSavings.prototype.getMonthlySavings = function (losgData, promotions) {
        var _this = this;
        if (losgData && promotions && promotions.length > 0 && this.totalMonthlySavings > 0) {
            var wlsCMSData_1 = wlsUtils.getWlsCmsData();
            var losgsInfo = losgData;
            this.monthlyCommonPromo = [];
            return (React.createElement(React.Fragment, null,
                this.getSavingTitle(this.savingsAndPromosCms.monthlySavingsTitle, this.totalMonthlySavings, 'MONTHLY'),
                losgsInfo.map(function (losg, index) {
                    var lineItems = wlsUtils.organizeLineItems(Object.values(losg.lineItems), _this.isMixAndMatch);
                    var deviceInfo = _this.getDeviceModel(lineItems);
                    var lineName = _this.getPromoLine(losg, index, wlsCMSData_1, _this.eapFlowContext, deviceInfo);
                    var keyId = "promoInfo" + losg.id + "_" + index;
                    return (React.createElement("div", { key: keyId }, _this.showMonthlySavings(lineItems, promotions, lineName)));
                }),
                (this.monthlyCommonPromo.length > 0) &&
                    React.createElement("div", { className: styles.savingsCommon }, this.monthlyCommonPromo)));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    WirelessSavings.prototype.getOneTimeSavings = function (losgData, promotions) {
        var _this = this;
        if (losgData && promotions && promotions.length > 0 && this.totalOneTimeSavings > 0) {
            var losgsInfo = losgData;
            this.actFeeItem = (React.createElement(React.Fragment, null));
            this.actFeeTotal = 0;
            this.upgFeeItem = (React.createElement(React.Fragment, null));
            this.upgFeeTotal = 0;
            this.oneTimeCombinedPromo = {};
            return (React.createElement(React.Fragment, null,
                this.totalMonthlySavings > 0 && React.createElement("div", { className: styles.solidLightGray }),
                this.getSavingTitle(this.savingsAndPromosCms.oneTimeSavingsTitle, this.totalOneTimeSavings, 'ONETIME'),
                losgsInfo.map(function (losg, index) {
                    var lineItems = wlsUtils.organizeLineItems(Object.values(losg.lineItems), _this.isMixAndMatch);
                    var keyId = "promoInfo" + losg.id + "_" + index;
                    return (React.createElement("div", { key: keyId }, lineItems.map(function (lineItem) {
                        keyId = "item" + lineItem.id + "_" + index;
                        var fromPromoRef = _this.getOneTimePromoFromReferences(lineItem, promotions);
                        _this.getOneTimePromotion(lineItem);
                        if (lineItem.uiDisplayLineItem) {
                            return (React.createElement(React.Fragment, { key: keyId }, fromPromoRef));
                        }
                        else {
                            return (React.createElement(React.Fragment, { key: keyId }));
                        }
                    })));
                }),
                this.actFeeItem,
                this.upgFeeItem,
                this.showSavings(this.oneTimeCombinedPromo),
                this.getRewards()));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    WirelessSavings.prototype.getOneTimePromoFromReferences = function (lineItem, promotions) {
        var _this = this;
        if (lineItem && lineItem.uiDisplayLineItem && lineItem.promotionReferences &&
            lineItem.promotionReferences.length > 0) {
            return (React.createElement(React.Fragment, null, lineItem.promotionReferences.map(function (promoRef, promoIndex) {
                var promotion = promotions.find(function (promo) { return promo.id === promoRef; });
                var keyId = "promo_" + lineItem.id + "_" + promoIndex;
                if (promotion && promotion.promotionCycle &&
                    promotion.promotionCycle.toUpperCase() !== 'MONTHLY' &&
                    !_this.isOneTimeCommonPromo(lineItem, promotion)) {
                    return (React.createElement(React.Fragment, { key: keyId }, _this.getPromotions(promotion)));
                }
                else {
                    return (React.createElement(React.Fragment, { key: keyId }));
                }
            })));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    WirelessSavings.prototype.getOneTimePromotion = function (lineItem) {
        if (lineItem && lineItem.uiDisplayLineItem && lineItem.fees && lineItem.fees.waivedIndicator &&
            (lineItem.fees.feeId === 'ACT' && lineItem.itemType.toUpperCase() === 'ACTIVATION_FEE')) {
            var priceData = wlsUtils.getLineItemPriceData(lineItem, this.isMixAndMatch, true);
            var waivedReason = lineItem.fees.waivedReason;
            var content = this.savingsAndPromosCms.activationLabel || 'Waived activation fee(s)';
            this.actFeeTotal = priceData.lineItemPrice.price + this.actFeeTotal;
            this.actFeeItem = (React.createElement("div", null, this.getSavingLine(content, this.actFeeTotal, 'ONETIME', waivedReason)));
            return true;
        }
        else if (lineItem && lineItem.uiDisplayLineItem && lineItem.fees && lineItem.fees.waivedIndicator &&
            lineItem.fees.feeId === 'UPG' && lineItem.itemType.toUpperCase() === 'UPGRADEFEE') {
            var priceData = wlsUtils.getLineItemPriceData(lineItem, this.isMixAndMatch, true);
            var waivedReason = lineItem.fees.waivedReason;
            var content = this.savingsAndPromosCms.upActivationLabel || 'Waived upgrade fee(s)';
            this.upgFeeTotal = priceData.lineItemPrice.price + this.upgFeeTotal;
            this.upgFeeItem = (React.createElement("div", null, this.getSavingLine(content, this.upgFeeTotal, 'ONETIME', waivedReason)));
            return true;
        }
        else {
            return false;
        }
    };
    WirelessSavings.prototype.getSavingLine = function (label, savings, cycle, waivedReason) {
        var _a;
        var promoPriceObj = wlsUtils.promoCyclePriceMsg(savings, cycle, true);
        var showPriceAmt = (savings && savings > 0) ? true : false;
        var isIRUCustomer = ((_a = this.payloadObj.b2bDetail) === null || _a === void 0 ? void 0 : _a.FAN) && !CartUtilFunctions_1.isSMBCustomer();
        var imageStyle = [icons.cccIconCart, icons.cccIconCartSignatureBookmark].join(' ');
        return (React.createElement("div", { className: styles.savingsLineItem },
            React.createElement("div", { className: styles.savingsContentB },
                this.isSignatureFlagEnabled && isIRUCustomer && (waivedReason === null || waivedReason === void 0 ? void 0 : waivedReason.toUpperCase()) === 'FAN' &&
                    !CartUtilFunctions_1.isFNIntentPresent() && !CartUtils.isFNUserWithConsumerLine() &&
                    React.createElement("span", { className: styles.iconBookmark32 }, (CartUtilFunctions_1.isAppreciationOfferPresent()) ?
                        React.createElement("img", { className: styles.appreciationIcon, src: 'https://www.att.com/idpassets/global/icons/svg/retail-financial/functional-icon_financial-security-filled_32.svg', alt: 'appreciationIcon' }) : React.createElement("i", { "aria-label": "Icon", className: imageStyle })),
                React.createElement(ui_components_1.RichText, { testId: utils_1.default('Wireless', cycle, 'SavingTitle'), data: { isDecodingRequired: false, text: label } })),
            showPriceAmt &&
                React.createElement("div", { className: styles.savingsPriceB },
                    React.createElement(ui_components_1.PriceContainer, { testId: cycle + '_Saving_Price', data: { billingNote: promoPriceObj.suffix, price: savings }, options: { accessibility: promoPriceObj.catoConten, decimalPoints: 2,
                            isDataPriceNegative: true,
                            overrideAccessibility: true, type: PriceContainerProps_1.PricingType.XSMALL } }))));
    };
    WirelessSavings.prototype.getRewards = function () {
        var _this = this;
        var rewardList = this.payloadObj && this.payloadObj.rewards;
        if (rewardList && rewardList.length > 0) {
            var yourSavingsCardCms = wlsUtils.getYourSavingsCardCmsData();
            var linkLabel_1 = yourSavingsCardCms && yourSavingsCardCms.seeOfferDetailsLinkLabel;
            return (rewardList.map(function (reward, index) {
                var promoPriceObj = wlsUtils.promoCyclePriceMsg(reward.amount, 'ONETIME', true);
                var showPriceAmt = reward.amount > 0 ? true : false;
                return (React.createElement("div", { key: "reward_" + index, className: styles.savingsLineItem },
                    React.createElement("div", { className: styles.savingsContentB },
                        React.createElement("span", null,
                            React.createElement(ui_components_1.RichText, { testId: utils_1.default('Wireless', 'reward' + index), data: { isDecodingRequired: false, text: Common.replaceHTMLEntities(reward.displayName) } })),
                        (reward.legalDescription || reward.redeemRewardDetails) && React.createElement("span", null,
                            React.createElement(components_1.Link, { kind: "textPlain", 
                                // tslint:disable-next-line: jsx-no-lambda
                                onClick: function () { return _this.openRewardModal(reward, linkLabel_1, true); }, testId: components_1.Link.name + '_' + linkLabel_1, className: CartConfiguration_scss_1.commonLinkSmall }, linkLabel_1))),
                    showPriceAmt &&
                        React.createElement("div", { className: styles.savingsPriceB },
                            React.createElement(ui_components_1.PriceContainer, { testId: 'ONETIME_Reward_Price', data: { billingNote: promoPriceObj.suffix, price: reward.amount }, options: { accessibility: promoPriceObj.catoConten, decimalPoints: 2,
                                    isDataPriceNegative: true,
                                    overrideAccessibility: true, type: PriceContainerProps_1.PricingType.XSMALL } }))));
            }));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    WirelessSavings.prototype.showSavings = function (combinedPromo) {
        var _this = this;
        if (combinedPromo) {
            return (Object.values(combinedPromo).map(function (promo) {
                return _this.getPromotions(promo);
            }));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    WirelessSavings.prototype.getDeviceModel = function (lineItemData) {
        var deviceInfo = {};
        if (lineItemData) {
            for (var _i = 0, lineItemData_1 = lineItemData; _i < lineItemData_1.length; _i++) {
                var element = lineItemData_1[_i];
                var device = wlsUtils.getDeviceMakeModel(element);
                if (device && device.model) {
                    deviceInfo = device;
                    break;
                }
            }
        }
        return deviceInfo;
    };
    WirelessSavings.prototype.showMonthlySavings = function (lineItems, promotions, lineName) {
        var _this = this;
        if (lineItems) {
            this.monthlyCombinedPromo = {};
            var monthlyPromoCycle_1 = false;
            lineItems.forEach(function (lineItem) {
                if (lineItem.uiDisplayLineItem && lineItem.promotionReferences &&
                    lineItem.promotionReferences.length > 0) {
                    var promotionList = wlsUtils.removeDuplicatePromo(lineItem, promotions);
                    if (promotionList && promotionList.length > 0) {
                        promotionList.forEach(function (promo, promoIndex) {
                            monthlyPromoCycle_1 = promo && promo.promotionCycle && promo.promotionCycle.toUpperCase() === 'MONTHLY';
                            if (monthlyPromoCycle_1) {
                                _this.isMonthlyCommonPromo(lineItem, promo);
                            }
                        });
                    }
                }
            });
            return (React.createElement(React.Fragment, null,
                monthlyPromoCycle_1 && lineName,
                this.showSavings(this.monthlyCombinedPromo)));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    WirelessSavings.prototype.openRewardModal = function (reward, linkName, openModal) {
        if (reward && openModal) {
            this.rewardInfo = reward;
            this.yourSavingsCardCms = wlsUtils.getYourSavingsCardCmsData();
            this.reportingService.fireLinkClickEvent(linkName, ReportingService_1.PageUrls.SEE_OFFER_MODAL_PAGE);
            this.savingsData.rewardModalEvent(true);
        }
        else {
            this.savingsData.rewardModalEvent(false);
        }
    };
    WirelessSavings.prototype.showRewardModalContent = function () {
        var _this = this;
        if (this.savingsData.showRewardModal) {
            return (React.createElement(ui_components_1.Modal, { testId: "Modal_SeeOffer_Details", options: { className: { modalContentClass: CartConfiguration_scss_1.rennyModalCloseBtn },
                    show: this.savingsData.showRewardModal, showClose: true }, events: { onClose: function () { return _this.openRewardModal({}, '', false); } }, accessibilityText: "_SeeOffer_Details" },
                React.createElement("div", { className: CartConfiguration_scss_1.rennyModalContainer },
                    React.createElement("div", null,
                        React.createElement(ui_components_1.Label, { data: { text: this.yourSavingsCardCms.seeOfferModalTitleLabel }, options: { className: CartConfiguration_scss_1.rennyModalTitle } })),
                    this.rewardInfo.legalDescription &&
                        React.createElement("div", { className: styles.legalContainer },
                            React.createElement("p", { dangerouslySetInnerHTML: {
                                    __html: Common.replaceHTMLEntities(this.rewardInfo.legalDescription),
                                } })),
                    this.rewardInfo.redeemRewardDetails &&
                        React.createElement("div", { className: styles.legalContainer },
                            React.createElement("p", { dangerouslySetInnerHTML: {
                                    __html: Common.replaceHTMLEntities(this.rewardInfo.redeemRewardDetails),
                                } })))));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    return WirelessSavings;
}());
exports.default = WirelessSavings;
//# sourceMappingURL=WirelessSavings.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/WirelessCart/WirelessSavings.js
// module id = 781
// module chunks = 8